<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-5">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" :hide-details="true" />
        </div>

        <div class="mb-4">
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.background"
                    @change="event => (fields.styleSection.background = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.background" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.styleSection.textColor"
                    @change="event => (fields.styleSection.textColor = event.target.value)"
                  />
                  <v-text-field v-model="fields.styleSection.textColor" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.topPadding"
                  label="Top Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.styleSection.bottomPadding"
                  label="Bottom Padding"
                  :hide-details="true"
                />
              </v-col>
              <v-col cols="12" md="12">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.containerPage.enableStyle"
                  label="Enable Style Container"
                  :hide-details="true"
                />
                <div v-if="fields.containerPage.enableStyle">
                  <v-row>
                    <v-col cols="12" md="6">
                      <label>Background Color</label>
                      <div class="d-flex align-center gap-3">
                        <input
                          type="color"
                          style="width: 40px; height: 40px; margin-right: 12px"
                          :value="fields.containerPage.background"
                          @change="event => (fields.containerPage.background = event.target.value)"
                        />
                        <v-text-field v-model="fields.containerPage.background" :hide-details="true" class="mt-0" />
                      </div>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Banner items</label>
            <v-btn small color="primary" @click="handleAddItem">Add Item</v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, i) in fields['list-item']" :key="`hsia-${i}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <span>Banner {{ i + 1 }}</span>
                  <v-btn :disabled="fields['list-item'].length === 1" icon @click.stop="handleRemoveItem(i)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-5">
                  <v-checkbox v-model="item.useMobile" label="Use mobile" class="mb-0 mt-0" :hide-details="true" />
                  <div v-if="item.useMobile">
                    <UploadImage
                      @callback="obj => handleUploadImageMobile(obj, i)"
                      :image="{ imageSrc: item.imageMobile }"
                      :resize="{ width: 1024, height: 'auto' }"
                      :height="`250`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveUploadMobile(i)"
                    />
                  </div>
                </div>
                <div class="mb-5">
                  <label>Desktop image</label>
                  <UploadImage
                    @callback="obj => handleUploadImage(obj, i)"
                    :image="{ imageSrc: item.image }"
                    :resize="{ width: 1920, height: 'auto' }"
                    :height="`250`"
                    :typeUpload="'image'"
                    @callbackDelete="handleRemoveUpload(i)"
                  />
                </div>
                <div>
                  <label>Link</label>
                  <v-text-field v-model="item.link" :hide-details="true" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';

const defaultBannerItem = () => ({
  image: '',
  imageMobile: '',
  useMobile: false,
  link: '#',
});

const defaultFields = () => ({
  title: 'Banner Hsia Section',
  styleSection: {
    topPadding: false,
    bottomPadding: false,
    background: '#FFFFFF',
    textColor: '#000000',
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  'list-item': [defaultBannerItem()],
});

export default {
  name: 'BannerHsiaSectionEditor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: defaultFields(),
    };
  },
  mounted() {
    const fallback = defaultFields();
    const extracted = this.sectionEditor.sectionExtract || {};
    const listItem =
      Array.isArray(extracted['list-item']) && extracted['list-item'].length
        ? extracted['list-item'].map(item => ({ ...defaultBannerItem(), ...item }))
        : [defaultBannerItem()];

    this.fields = {
      ...fallback,
      ...extracted,
      styleSection: {
        ...fallback.styleSection,
        ...(extracted.styleSection || {}),
      },
      containerPage: {
        ...fallback.containerPage,
        ...(extracted.containerPage || {}),
      },
      'list-item': listItem,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionBannerHsia(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj, i) {
      this.fields['list-item'][i].image = obj.imageSrc;
    },
    handleUploadImageMobile(obj, i) {
      this.fields['list-item'][i].imageMobile = obj.imageSrc;
    },
    handleRemoveUpload(i) {
      this.fields['list-item'][i].image = '';
    },
    handleRemoveUploadMobile(i) {
      this.fields['list-item'][i].imageMobile = '';
    },
    handleAddItem() {
      this.fields['list-item'].push(defaultBannerItem());
    },
    handleRemoveItem(i) {
      if (this.fields['list-item'].length <= 1) return;
      this.fields['list-item'].splice(i, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  border: 1px solid #0000000f;
  border-radius: 8px;
  padding: 16px 12px;
  margin-bottom: 10px;
}
</style>
